import React from "react";
import { Checkbox, Dropdown, MenuItem } from "react-bootstrap";
import locale from "../../../../locale";

const diffStartTimeoutList = [
    { value: 3600000, label: 'hour' },
    { value: 86400000, label: 'day' },
    { value: 604800000, label: 'week' },
    { value: 2592000000, label: 'month' }
];

const DiffStartTimeout = ({ diffStartTimeout, onSaveSettings }) => {

    return (
        <>
            <Checkbox
                checked={!!diffStartTimeout}
                onChange={(e) => onSaveSettings({ diffStartTimeout: e.target.checked ? diffStartTimeoutList[0].value : "" })}
            >
                {locale('settings.diffStartTimeout.title')}
            </Checkbox>
            <Dropdown id="diff-show-timout" style={{ marginBottom: '20px' }} disabled={!diffStartTimeout}>
                <Dropdown.Toggle>
                    {locale(`settings.diffStartTimeout.${diffStartTimeoutList.find(item => item.value === Number(diffStartTimeout))?.label || 'hour'}`)}
                </Dropdown.Toggle>
                <Dropdown.Menu>
                    {
                            diffStartTimeoutList.map((item) => (
                            <MenuItem
                                key={item.value}
                                onClick={() => onSaveSettings({ diffStartTimeout: item.value })}
                            >
                                {locale(`settings.diffStartTimeout.${item.label}`)}
                            </MenuItem>
                        ))
                    }
                </Dropdown.Menu>
            </Dropdown>
        </>
    );
};

export default DiffStartTimeout;
